import { createSlice } from '@reduxjs/toolkit';
import { isServer } from '../../library/helpers/isServer';
import { getDefaultPath } from '../../library/helpers/url_sync';

const preKeys = getDefaultPath();

const getView = (width) => {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
};

const appInitialState = {
  collapsed: !isServer && window.innerWidth > 1220 ? false : true,
  view: !isServer && getView(window.innerWidth),
  height: !isServer && window.innerHeight,
  openDrawer: false,
  openKeys: preKeys,
  current: preKeys,
};

export const appSlice = createSlice({
  name: 'app',
  initialState: appInitialState,
  reducers: {
    toggleOpenDrawer: (state) => {
      state.openDrawer = !state.openDrawer;
    },
    toggleCollapsed: (state) => {
      state.collapsed = !state.collapsed;
    },
    toggleAll: (state, action) => {
      const { width, height } = action.payload;
      const view = getView(width);

      if (state.view !== view || state.height !== height) {
        state.collapsed = view !== 'DesktopView';
        state.height = height || state.height;
        state.view = view;
      }
    },
    changeOpenKeys: (state, action) => {
      if (action.payload !== undefined || action.payload !== null) {
        state.openKeys = action.payload;
      }
    },
    changeCurrent: (state, action) => {
      state.current = action.payload.current;
    },
    clearMenu: (state) => {
      state.openKeys = [];
      state.current = [];
    },
  },
});

export const {
  toggleAll,
  toggleOpenDrawer,
  toggleCollapsed,
  changeOpenKeys,
  changeCurrent,
  clearMenu,
} = appSlice.actions;

export default appSlice.reducer;
